import { createDisclosureStore } from "../disclosure/disclosure-store.js";
//#region src/dialog/dialog-store.ts
/**
* Creates a dialog store.
*/
function createDialogStore(props = {}) {
	return createDisclosureStore(props);
}
//#endregion
export { createDialogStore };

//# sourceMappingURL=dialog-store.js.map